import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputEmailErrorMessage = (
  <Trans>
    Ce champ doit contenir un email valide
  </Trans>
);
